import type {
  ChainModifiers,
  Entry,
  EntryFieldTypes,
  EntrySkeletonType,
  LocaleCode,
} from 'contentful';

export interface TypeProfileFields {
  identifier: EntryFieldTypes.Symbol;
  name: EntryFieldTypes.Symbol;
  title: EntryFieldTypes.Symbol;
  profileDescription?: EntryFieldTypes.RichText;
  email?: EntryFieldTypes.Symbol;
  image?: EntryFieldTypes.AssetLink;
  cutoutImage?: EntryFieldTypes.AssetLink;
}

export type TypeProfileSkeleton = EntrySkeletonType<TypeProfileFields, 'profile'>;
export type TypeProfile<
  Modifiers extends ChainModifiers = 'WITHOUT_UNRESOLVABLE_LINKS',
  Locales extends LocaleCode = LocaleCode,
> = Entry<TypeProfileSkeleton, Modifiers, Locales>;

export function isTypeProfile<Modifiers extends ChainModifiers, Locales extends LocaleCode>(
  entry: Entry<EntrySkeletonType, Modifiers, Locales>,
): entry is TypeProfile<Modifiers, Locales> {
  return entry.sys.contentType.sys.id === 'profile';
}
